import { Option } from '@teetsh/app/src/components/Form/AutoSuggest';
import parse from '@teetsh/app/src/utils/time/parse';
import { getFloorStepTime } from './getFloorStepTime';
import { format } from '@teetsh/app/src/utils/time/format';
import { timeFormat } from '@teetsh/app/src/components/Form/TimePicker2/InputTimePicker';
import isValid from '@teetsh/app/src/utils/time/isValid';
import { UserLocale } from '@teetsh/app/src/types/user';

export function getNearestSlot(
  suggestions: Option[],
  value: string,
  timeGap: number,
  locale: UserLocale,
): Option | undefined {
  const valueDate = parse(value, timeFormat, new Date());
  if (isValid(valueDate)) {
    const tt = getFloorStepTime(valueDate, timeGap);
    return suggestions.find(s => s.value === format(tt, locale, timeFormat));
  }
  return undefined;
}
